import { ContactLocationModel } from '../models';

export class ContactLocationModelFactory {
  public create(location: ContactLocationModel): ContactLocationModel {
    location = Object.assign(new ContactLocationModel(), location);
    delete location['raw'];
    return location;
  }
}
